import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { Announcement } from '@/api/spec';
import { clearDataMigration, CURRENT_APP_VERSION } from '@/utils/zustand_helpers';

export interface AnnouncementsState {
  announcements: Announcement[];
  readIds: number[];
  setAnnouncements: (announcements: Announcement[]) => void;
  markRead: (id: number) => void;
}

export const useAnnouncementsStore = create<AnnouncementsState>()(
  persist(
    (set, get) => ({
      announcements: [],
      readIds: [],
      setAnnouncements: (announcements) => set({ announcements }),
      markRead: (id) => set((state) => ({ readIds: [...state.readIds, id] })),
    }),
    {
      name: 'dex-announcements',
      version: CURRENT_APP_VERSION,
      migrate: clearDataMigration,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        readIds: state.readIds,
      }),
    }
  )
);
